import memoize from 'transmute/memoize';
export const getFlattenedProperties = memoize(propertiesByGroup => {
  return propertiesByGroup.flatMap(group => group.properties);
});